// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variants — all typography settings driven by --typography-* tokens in general.css */
.TextCommon-module_display1__q4sus {
    font: var(--typography-display1);
}

.TextCommon-module_display2__SvPwf {
    font: var(--typography-display2);
}

.TextCommon-module_header__n1FfG {
    font: var(--typography-header);
}

.TextCommon-module_main__F5Q93 {
    font: var(--typography-main);
}

.TextCommon-module_mCardNo__PtW8N {
    font: var(--typography-mCardNo);
    letter-spacing: var(--typography-mCardNo-spacing);
    font-variant-numeric: var(--typography-mCardNo-numeric);
}

.TextCommon-module_subheader__pxh7V {
    font: var(--typography-subheader);
    text-transform: var(--typography-subheader-transform);
}

.TextCommon-module_secondary__Rqn7g {
    font: var(--typography-secondary);
}

.TextCommon-module_tag__j1Q6u {
    font: var(--typography-tag);
    text-transform: var(--typography-tag-transform);
    letter-spacing: var(--typography-tag-spacing);
}

/* Font weight overrides — applied via optionFontWeight prop. Override BOTH family and weight
   so \`font:\` shorthand in variant (which sets font-weight) is properly replaced. */
.TextCommon-module_fontWeightMedium__vajqE {
    font-family: var(--font-family-medium);
    font-weight: var(--font-family-medium-weight);
}

.TextCommon-module_fontWeightBold__Xn3ZB {
    font-family: var(--font-family-bold);
    font-weight: var(--font-family-bold-weight);
}

/* Text Align */
.TextCommon-module_textAlignStart__zX2k9 {
    text-align: start;
}

.TextCommon-module_textAlignCenter___YKTd {
    text-align: center;
}

.TextCommon-module_textAlignEnd__pHhZn {
    text-align: end;
}

.TextCommon-module_textAlignJustify__T5sSj {
    text-align: justify;
}

.TextCommon-module_smallCaps__JQwwk {
    text-transform: var(--typography-smallCaps-transform);
}

.TextCommon-module_ellipsis__Er1CZ {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.TextCommon-module_lineThrough__pMDzl {
    text-decoration: line-through;
}

.TextCommon-module_actionable__qHtGS {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Text/TextCommon.module.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;IACjD,uDAAuD;AAC3D;;AAEA;IACI,iCAAiC;IACjC,qDAAqD;AACzD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;IAC/C,6CAA6C;AACjD;;AAEA;mFACmF;AACnF;IACI,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA,eAAe;AACf;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* Variants — all typography settings driven by --typography-* tokens in general.css */\n.display1 {\n    font: var(--typography-display1);\n}\n\n.display2 {\n    font: var(--typography-display2);\n}\n\n.header {\n    font: var(--typography-header);\n}\n\n.main {\n    font: var(--typography-main);\n}\n\n.mCardNo {\n    font: var(--typography-mCardNo);\n    letter-spacing: var(--typography-mCardNo-spacing);\n    font-variant-numeric: var(--typography-mCardNo-numeric);\n}\n\n.subheader {\n    font: var(--typography-subheader);\n    text-transform: var(--typography-subheader-transform);\n}\n\n.secondary {\n    font: var(--typography-secondary);\n}\n\n.tag {\n    font: var(--typography-tag);\n    text-transform: var(--typography-tag-transform);\n    letter-spacing: var(--typography-tag-spacing);\n}\n\n/* Font weight overrides — applied via optionFontWeight prop. Override BOTH family and weight\n   so `font:` shorthand in variant (which sets font-weight) is properly replaced. */\n.fontWeightMedium {\n    font-family: var(--font-family-medium);\n    font-weight: var(--font-family-medium-weight);\n}\n\n.fontWeightBold {\n    font-family: var(--font-family-bold);\n    font-weight: var(--font-family-bold-weight);\n}\n\n/* Text Align */\n.textAlignStart {\n    text-align: start;\n}\n\n.textAlignCenter {\n    text-align: center;\n}\n\n.textAlignEnd {\n    text-align: end;\n}\n\n.textAlignJustify {\n    text-align: justify;\n}\n\n.smallCaps {\n    text-transform: var(--typography-smallCaps-transform);\n}\n\n.ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.lineThrough {\n    text-decoration: line-through;\n}\n\n.actionable {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"display1": `TextCommon-module_display1__q4sus`,
	"display2": `TextCommon-module_display2__SvPwf`,
	"header": `TextCommon-module_header__n1FfG`,
	"main": `TextCommon-module_main__F5Q93`,
	"mCardNo": `TextCommon-module_mCardNo__PtW8N`,
	"subheader": `TextCommon-module_subheader__pxh7V`,
	"secondary": `TextCommon-module_secondary__Rqn7g`,
	"tag": `TextCommon-module_tag__j1Q6u`,
	"fontWeightMedium": `TextCommon-module_fontWeightMedium__vajqE`,
	"fontWeightBold": `TextCommon-module_fontWeightBold__Xn3ZB`,
	"textAlignStart": `TextCommon-module_textAlignStart__zX2k9`,
	"textAlignCenter": `TextCommon-module_textAlignCenter___YKTd`,
	"textAlignEnd": `TextCommon-module_textAlignEnd__pHhZn`,
	"textAlignJustify": `TextCommon-module_textAlignJustify__T5sSj`,
	"smallCaps": `TextCommon-module_smallCaps__JQwwk`,
	"ellipsis": `TextCommon-module_ellipsis__Er1CZ`,
	"lineThrough": `TextCommon-module_lineThrough__pMDzl`,
	"actionable": `TextCommon-module_actionable__qHtGS`
};
export default ___CSS_LOADER_EXPORT___;
